import { Box, Popover, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getTokenUser, removeTokenUser, setToken } from "../api/token";
import { logout } from "../api/user";
import userPic from "../assets/image/user-profile2.png";
import Group from "../assets/SVG/group";
import LogoutIcon from "../assets/SVG/logoutIcon";
import ProfileIcon from "../assets/SVG/profileIcon";

export default function Logoutpop({
  openPopover,
  setOpenPopover,
  setOpenProfilePop,
  groupInfo,
}) {
  const navigate = useNavigate();

  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setOpenPopover(false);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  useEffect(() => {
    if (openPopover) {
      setAnchorEl(openPopover);
    }
    if (openPopover === true) {
      setAnchorEl(openPopover);
    }
  }, [openPopover]);
  return (
    <Popover
      sx={{
        "& .MuiPaper-root": {
          width: "264px",
          height: "220px",
          padding: "22px 23px",
          borderRadius: "13px",
          ml: "-10px",
          mt: "20px",
        },
        "& .MuiBackdrop-root": {
          backgroundColor: "#00000060",
        },
      }}
      id={id}
      open={open}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
    >
      <Box style={{ margin: "auto", width: "fit-content" }}>
        <img src={userPic} />
      </Box>
      <Box
        onClick={() => {
          setOpenProfilePop("person");
          handleClose();
        }}
        sx={{ cursor: "pointer" }}
        display="flex"
        mt="25px"
      >
        <ProfileIcon />
        <Typography mr="10px" color="#757278" fontSize="16px">
          {"مشاهده پروفایل"}
        </Typography>
      </Box>
      {groupInfo && (
        <Box
          onClick={() => {
            setOpenProfilePop("group");
            handleClose();
          }}
          sx={{ cursor: "pointer" }}
          display="flex"
          mt="10px"
        >
          <Group color="#757278" />
          <Typography mr="10px" color="#757278" fontSize="16px">
            {"مشاهده پروفایل گروه "}
          </Typography>
        </Box>
      )}
      <Box
        onClick={() =>
          logout()
            .then(() => {
              if (getTokenUser()) {
                setToken(getTokenUser());
                removeTokenUser();
                navigate("/");
                window.location.reload();
              } else {
                navigate("/login");
              }
            })
            .catch(() => {})
        }
        sx={{ cursor: "pointer" }}
        display="flex"
        mt="10px"
      >
        <LogoutIcon />
        <Typography mr="10px" color="#E24B4B" fontSize="16px">
          {"خروج از حساب کاربری"}
        </Typography>
      </Box>
    </Popover>
  );
}
